<template>
  <div class="px-2-5 d-block position-relative">
    <p class="mb-1-5 body-2-1">{{ routeType.title }} :</p>
    <div class="w-100 mb-2">
      <div v-for="product in routeType.data" class="d-flex align-items-center mb-1-5">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex w-100">
            <svg @click="removeProduct(product.data.id)" class="lh-1 flex-shrink-0 cursor-pointer" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.85946 11.1942C3.63243 11.1942 3.4869 11.0603 3.47526 10.8391L3.30062 4.42994C3.2948 4.21455 3.44033 4.07484 3.67318 4.07484C3.88856 4.07484 4.03992 4.20873 4.04574 4.42412L4.23202 10.8391C4.23784 11.0545 4.08648 11.1942 3.85946 11.1942ZM5.63495 11.1942C5.40789 11.1942 5.25072 11.0545 5.25072 10.8391V4.42994C5.25072 4.21455 5.40789 4.07484 5.63495 4.07484C5.86196 4.07484 6.02494 4.21455 6.02494 4.42994V10.8391C6.02494 11.0545 5.86196 11.1942 5.63495 11.1942ZM7.41622 11.1942C7.18921 11.1942 7.03785 11.0545 7.04366 10.8391L7.22413 4.42994C7.22994 4.20873 7.3813 4.07484 7.59669 4.07484C7.82951 4.07484 7.97506 4.21455 7.96924 4.42994L7.79459 10.8391C7.78297 11.0603 7.63742 11.1942 7.41622 11.1942ZM3.07942 2.66029H4.00499V1.41455C4.00499 1.08275 4.23784 0.867358 4.58711 0.867358H6.67111C7.02037 0.867358 7.25324 1.08275 7.25324 1.41455V2.66029H8.17877V1.35634C8.17877 0.512266 7.63161 0 6.73514 0H4.52308C3.62661 0 3.07942 0.512266 3.07942 1.35634V2.66029ZM0.43659 3.12599H10.8391C11.0778 3.12599 11.2699 2.92224 11.2699 2.68357C11.2699 2.44491 11.0778 2.24699 10.8391 2.24699H0.43659C0.203742 2.24699 0 2.44491 0 2.68357C0 2.92807 0.203742 3.12599 0.43659 3.12599ZM2.96881 12.9638H8.30688C9.13927 12.9638 9.69811 12.4224 9.73889 11.59L10.1464 3.00374H1.12349L1.5368 11.5959C1.57755 12.4283 2.12474 12.9638 2.96881 12.9638Z"
                fill="#DC3545" />
            </svg>
            <span class="lh-1-3 mb-0 body-3-3-2 ml-2 mr-1">{{ product.qty }}x</span>
            <span class="lh-1-3 mb-0 body-3-3-2">{{ product.data.name }}</span>
          </div>
          <span :id="`${roomId}-${guestIndex}-${routeType.code}-${product.data.id}`" class="lh-1-3 mb-0 text-12 font-lato text-orange pl-2" :class="{'text-underline-dashed-offset-2 cursor-help' : product.data.cm_transport_route_type === 'ROUNDTRIP'}">{{ printTotalPrice(product) }}</span>
          <b-tooltip v-if="product.data.cm_transport_route_type === 'ROUNDTRIP'" :target="`${roomId}-${guestIndex}-${routeType.code}-${product.data.id}`" placement="bottom">
            This price includes both pickup and dropoff transfers
          </b-tooltip>
        </div>
      </div>
    </div>
    <div class="d-flex pl-1 mb-2">
      <svg class="mr-2" style="margin-top: 5px !important;" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6C4.64119 6 6 4.63825 6 3C6 1.35883 4.63825 0 2.99706 0C1.35883 0 0 1.35883 0 3C0 4.63825 1.36177 6 3 6Z" fill="#222222"/>
      </svg>

      <date-range-picker
        ref="serviceDate"
        class="transport-calendar"
        :class="{'z-index-1039' : !showCalendar}"
        v-model="serviceDateTime" 
        :ranges="false"
        single-date-picker="single"
        time-picker
        @toggle="handleToggleCalendar"
        @update="saveServiceDate">
        <template v-slot:input="picker">
          <div class="d-flex align-items-top w-100 text-left">
            <p class="mb-0 font-lato-regular text-12 flex-shrink-0 lh-1-2 text-light-dark">{{ `${routeType.title} time :` }}</p>
            <p class="mb-0 font-lato-regular text-12 ml-2 underline lh-1-2" style="text-underline-offset: 2px;" :class="$v.serviceDateTime.startDate.$error ? 'text-danger shake-el' : 'text-dark'">{{ serviceDateTimeFormatted }}</p>
          </div>
        </template>
      </date-range-picker>
    </div>
    <div class="d-flex pl-1">
      <svg class="mr-2" style="margin-top: 5px !important;"  width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6C4.64119 6 6 4.63825 6 3C6 1.35883 4.63825 0 2.99706 0C1.35883 0 0 1.35883 0 3C0 4.63825 1.36177 6 3 6Z" fill="#222222"/>
      </svg>

      <div class="d-flex align-items-top w-100 text-left">
        <div class="d-flex align-items-center">
          <p class="mb-0 font-lato-regular text-12 flex-shrink-0 lh-1-2 text-light-dark">Flight Number (optional)</p>
          <svg :id="`${routeType.code}_${roomId}_${guestIndex}_flightnumber`" class="lh-1 mx-1 cursor-help" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 15.9921C12.3765 15.9921 16 12.3626 16 7.99605C16 3.62175 12.3687 0 7.99217 0C3.62354 0 0 3.62175 0 7.99605C0 12.3626 3.63138 15.9921 8 15.9921ZM8 14.6595C4.29805 14.6595 1.34118 11.6962 1.34118 7.99605C1.34118 4.29593 4.29021 1.33268 7.99217 1.33268C11.6942 1.33268 14.6667 4.29593 14.6667 7.99605C14.6667 11.6962 11.702 14.6595 8 14.6595Z"
              fill="#777" />
            <path
              d="M6.62746 12.3861H9.81964C10.1412 12.3861 10.3921 12.1509 10.3921 11.8295C10.3921 11.5238 10.1412 11.2808 9.81964 11.2808H8.84711V7.29053C8.84711 6.86721 8.63528 6.58501 8.23532 6.58501H6.76082C6.43922 6.58501 6.18824 6.82801 6.18824 7.13379C6.18824 7.45515 6.43922 7.69036 6.76082 7.69036H7.60004V11.2808H6.62746C6.3059 11.2808 6.05492 11.5238 6.05492 11.8295C6.05492 12.1509 6.3059 12.3861 6.62746 12.3861ZM7.92946 5.28369C8.50196 5.28369 8.94904 4.82901 8.94904 4.25675C8.94904 3.68448 8.50196 3.2298 7.92946 3.2298C7.36472 3.2298 6.9098 3.68448 6.9098 4.25675C6.9098 4.82901 7.36472 5.28369 7.92946 5.28369Z"
              fill="#777" />
          </svg>
          <b-tooltip :target="`${routeType.code}_${roomId}_${guestIndex}_flightnumber`" placement="bottom">
            {{ 
              routeType.code === 'PICKUP' ? 
              'Flight number helps our driver track your arrival time in case of delays.' :
              'Flight number helps us schedule your pickup based on your departure time'
            }}
          </b-tooltip>
          <p class="mb-0 font-lato-regular text-12 flex-shrink-0 lh-1-2 text-light-dark"> :</p>
        </div>
        <div class="transport-input">
          <input type="text" class="no-focus-border" placeholder="e.g. XX1234" v-model="flightNumber" @input="saveFlightNumber()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import moment from 'moment';
  import 'moment-timezone'
  import { validationMixin } from "vuelidate";
  const { required } = require("vuelidate/lib/validators");

  export default {
    props:['routeType', 'roomId', 'guestIndex'],
    components:{
      DateRangePicker
    },
    data(){
      return{
        serviceDateTime:{
          startDate: null,
          endDate: null
        },
        showCalendar: false,
        flightNumber: '',
        debounceTimer: null
      }
    },
    mixins: [validationMixin],
    validations:{
      serviceDateTime: {
        startDate: {
          required
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getBeCartRoom']),
      serviceDateTimeFormatted(){
        const { startDate: date } = this.serviceDateTime 
        if(date === null) return "Select date & time";
        
        const m = moment(date).tz(this.getMerchant.timezone, true);
        const totalMin = m.utcOffset();
        const sign = totalMin < 0 ? "-" : "+";
        const absMin = Math.abs(totalMin);
        const hh = Math.floor(absMin / 60);
        const mm = absMin % 60;
        const label = mm ? `GMT${sign}${hh}:${String(mm).padStart(2, "0")}` : `GMT${sign}${hh}`;

        const pattern = 'ddd, DD MMM YYYY, HH:mm';
        return `${m.locale('en').format(pattern)} (${label})`;
      }
    },
    mounted(){
      this.$emit('refreshRef');
      this.getAdditionalDataFromStore();
    },
    methods:{
      ...mapMutations(['removeAdditionalProductToRoom', 'saveTransportDataPerRoom']),
      printTotalPrice(product){
        const { qty, data: { cm_transport_route_type: routeType, price } } = product;

        const isRoundTrip = routeType === 'ROUNDTRIP';
        const currentRouteTypeDropoff = this.routeType.code === 'DROPOFF';
        if(isRoundTrip && currentRouteTypeDropoff) return "Included";

        const totalPrice = Number(price) * qty;

        return this.$formatCurrency(totalPrice);
      },
      removeProduct(productId){
        this.removeAdditionalProductToRoom({
          roomId: this.roomId, 
          guestIndex: this.guestIndex, 
          productId
        });
      },
      handleToggleCalendar(currentStatus){
        this.showCalendar = currentStatus;
      },
      getAdditionalDataFromStore(){
        const savedRooms = this.$deepCopy(this.getBeCartRoom);

        const savedRoomIndex = savedRooms.findIndex(room => room.room_rate.id === this.roomId);

        if(savedRoomIndex === -1) return;

        const selectedRoom = savedRooms[savedRoomIndex].guest[this.guestIndex];

        if(this.$isEmpty(selectedRoom[this.routeType.code])) return;

        if(this.$isNotEmptyV2(selectedRoom[this.routeType.code].date)){
          this.serviceDateTime = {
            startDate: selectedRoom[this.routeType.code].date,
            endDate: selectedRoom[this.routeType.code].date
          }
        }

        if(this.$isNotEmptyV2(selectedRoom[this.routeType.code].flight_number)){
          this.flightNumber = selectedRoom[this.routeType.code].flight_number;
        }
      },
      storeAdditionalData(key, value){
        this.saveTransportDataPerRoom({
          roomId: this.roomId, 
          guestIndex: this.guestIndex, 
          routeType: this.routeType.code,
          key, value
        })
      },
      saveServiceDate(){
        this.storeAdditionalData('date', this.serviceDateTime.startDate)
      },
      saveFlightNumber(){
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
          this.storeAdditionalData('flight_number', this.flightNumber);
        }, 500);
      },
      validateServiceDate(){
        this.$v.serviceDateTime.$reset();
        this.$v.serviceDateTime.$touch();

        if(this.$v.serviceDateTime.$invalid){
          if(this.$refs.serviceDate){
            this.$smoothScroll(`room-cart-${this.roomId}-${this.guestIndex}`)
            this.showCalendar = true;
            setTimeout(() => {
              this.$refs.serviceDate.togglePicker(true)
            }, 100);
          }
        }

        return !this.$v.serviceDateTime.$invalid
      }
    }
  }
</script>

<style>
  .transport-input{
    border-bottom: 1px solid #222;
    margin-left: 0.5rem !important;
    line-height: 1 !important;
    margin-top: -2px;
  }
  .transport-input input{
    font-family: Lato-Regular !important;
    font-size: 12px;
    color: #222;
    padding: 0px;
    border: none !important;
    line-height: 1 !important;
    width: 70px;
  }
  .transport-input input::placeholder{
    font-family: Lato-Regular !important;
    font-size: 12px;
    color: #777 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/PerRoomCartProduct.vue